import { ValidatorCommon } from '../../utils/validator';

export namespace RegisterValidate {
    export function validate(val: any) {
        const errorStack: string[] = [];
        const errorPush = (err: string) => {
            errorStack.push(err);
        };
        if (!ValidatorCommon.nullValidate(val.email.trim())) {
            errorPush('Email Address Is Empty');
        }
        if (!ValidatorCommon.isEmail(val.email.trim())) {
            errorPush('Invalid Email Address');
        }
        if (!ValidatorCommon.nullValidate(val.password.trim())) {
            errorPush('Password Is Empty');
        }
        if (!ValidatorCommon.nullValidate(val.passwordAlt.trim()) || val.passwordAlt.trim() !== val.password.trim()) {
            errorPush('Your password and confirmation password do not match');
        }
        if (errorStack.length <= 0) {
            return 'validated';
        } else {
            return errorStack[0];
        }
    }
}
